<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC"><a id="page5"></a><a id="page6"></a><a id="page7"></a><a id="page8"></a><a id="page9">Contents</a></h1><a id="page9">
</a><p class="toc1" style="margin-top:20px;"><a id="page9"></a><a href="#/7chap1#chap1">Introduction</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/8chap2#chap2">Part I THE SURGEONS</a></p>
<p class="toc2"><a href="#/9chap3#chap3">Chapter 1 The Birth of a Dream</a></p>
<p class="toc2"><a href="#/10chap4#chap4">Chapter 2 The Heart of the Matter</a></p>
<p class="toc2"><a href="#/11chap5#chap5">Chapter 3 The Crusader</a></p>
<p class="toc2"><a href="#/12chap6#chap6">Chapter 4 The Making of a Miracle</a></p>
<p class="toc2"><a href="#/13chap7#chap7">Chapter 5 The Saga Continues</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/14chap8#chap8">Part II THE DONOR</a></p>
<p class="toc2"><a href="#/15chap9#chap9">Chapter 6 Richie Becker</a></p>
<p class="toc2"><a href="#/16chap10#chap10">Chapter 7 Dealing with Death</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/17chap11#chap11">Part III PITTSBURGH</a></p>
<p class="toc2"><a href="#/18chap12#chap12">Chapter 8 The Court of Last Resort</a></p>
<p class="toc2"><a href="#/19chap13#chap13">Chapter 9 Slowly Dying</a></p>
<p class="toc2"><a href="#/20chap14#chap14">Chapter 10 Face to Face</a></p>
<p class="toc2"><a href="#/21chap15#chap15">Chapter 11 Beyond the “God Squad”</a></p>
<p class="toc1" style="margin-top:20px;"><a id="page10"></a><a href="#/22chap16#chap16">Part IV THE WAIT</a></p>
<p class="toc2"><a href="#/23chap17#chap17">Chapter 12 Hope and Despair</a></p>
<p class="toc2"><a href="#/24chap18#chap18">Chapter 13 No Matter How Long the Night, the Day Is Sure to Follow</a></p>
<p class="toc2"><a href="#/25chap19#chap19">Chapter 14 The “Patient-Pioneer”</a></p>
<p class="toc2"><a href="#/26chap20#chap20">Chapter 15 That Magic Moment</a></p>
<p class="toc2"><a href="#/27chap21#chap21">Chapter 16 Tragedy</a></p>
<p class="toc2"><a href="#/28chap22#chap22">Chapter 17 Is Enough Ever Enough?</a></p>
<p class="toc2"><a href="#/29chap23#chap23">Chapter 18 Return to Pittsburgh</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/30chap24#chap24">Part V THE PROCEDURE</a></p>
<p class="toc2"><a href="#/31chap25#chap25">Chapter 19 The Cult</a></p>
<p class="toc2"><a href="#/32chap26#chap26">Chapter 20 First Cut</a></p>
<p class="toc2"><a href="#/33chap27#chap27">Chapter 21 The Procurement</a></p>
<p class="toc2"><a href="#/34chap28#chap28">Chapter 22 The Transplant</a></p>
<p class="toc2"><a href="#/35chap29#chap29">Chapter 23 Just Another Goddamn Miracle!</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/36chap30#chap30">Part VI LIFE AFTER TRANSPLANTATION</a></p>
<p class="toc2"><a href="#/37chap31#chap31">Chapter 24 The Long Road Home</a></p>
<p class="toc2"><a href="#/38chap32#chap32">Chapter 25 Setbacks and Disappointments</a></p>
<p class="toc2"><a href="#/39chap33#chap33">Chapter 26 Syndrome or Disease!</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/40chap34#chap34">Epilogue</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/41chap35#chap35">Afterword</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/42page#index">Index</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/43chap36#chap36">Acknowledgments</a></p>
<p class="toc1"><a href="#/44about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?5dbbc4d5